import {
  CLEAR_AUTH_STATE,
  EMAIL_OTP_FAILURE,
  EMAIL_OTP_REQUEST,
  EMAIL_OTP_SUCCESS,
  EMAIL_VERIFICATION_FAILURE,
  EMAIL_VERIFICATION_REQUEST,
  EMAIL_VERIFICATION_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  SEND_RESET_PASSWORD_FAILURE,
  SEND_RESET_PASSWORD_REQUEST,
  SEND_RESET_PASSWORD_SUCCESS,
  SEND_SMS_OTP_FAILURE,
  SEND_SMS_OTP_REQUEST,
  SEND_SMS_OTP_SUCCESS,
  SIGNUP_FAILURE,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SMS_OTP_SIGNIN_FAILURE,
  SMS_OTP_SIGNIN_REQUEST,
  SMS_OTP_SIGNIN_SUCCESS,
} from "./ActionType";

const initialState = {
  loading: false,
  error: null,
  loginResponse: {},
  success: null,

  sentEmailOtpResult: {},
  sentEmailOtpLoading: false,
  sentEmailOtpError: null,

  emailVerificationResult: {},
  emailVerificationLoading: false,
  emailVerificationError: null,

  registerRequestResult: {},
  registerRequestLoading: false,
  registerRequestError: null,

  userLoginResult: {},
  userLoginLoading: false,
  userLoginError: null,

  sentForgotPasswordTokenResult: {},
  sentForgotPasswordTokenLoading: false,
  sentForgotPasswordTokenError: null,

  resetPasswordResult: {},
  resetPasswordLoading: false,
  resetPasswordError: null,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case [SEND_SMS_OTP_REQUEST, SMS_OTP_SIGNIN_REQUEST]:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SEND_SMS_OTP_SUCCESS:
      return {
        ...state,
        success: action.payload,
        loading: false,
        error: null,
      };
    case [SEND_SMS_OTP_FAILURE, SMS_OTP_SIGNIN_FAILURE]:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SMS_OTP_SIGNIN_SUCCESS:
      return {
        ...state,
        loginResponse: action.payload,
        loading: false,
        error: null,
      };
    case EMAIL_OTP_REQUEST:
      return {
        ...state,
        sentEmailOtpLoading: true,
        sentEmailOtpError: null,
      };
    case EMAIL_OTP_SUCCESS:
      return {
        ...state,
        sentEmailOtpLoading: false,
        sentEmailOtpError: null,
        sentEmailOtpResult: action.payload,
      };
    case EMAIL_OTP_FAILURE:
      return {
        ...state,
        sentEmailOtpLoading: false,
        sentEmailOtpError: action.payload,
      };
    case EMAIL_VERIFICATION_REQUEST:
      return {
        ...state,
        emailVerificationLoading: true,
        emailVerificationError: null,
      };

    case EMAIL_VERIFICATION_SUCCESS:
      return {
        ...state,
        emailVerificationLoading: false,
        emailVerificationError: null,
        emailVerificationResult: action.payload,
      };

    case EMAIL_VERIFICATION_FAILURE:
      return {
        ...state,
        emailVerificationLoading: false,
        emailVerificationError: action.payload,
      };

    case SIGNUP_REQUEST:
      return {
        ...state,
        registerRequestLoading: true,
        registerRequestError: null,
      };
    case SIGNUP_SUCCESS:
      return {
        ...state,
        registerRequestLoading: false,
        registerRequestError: null,
        registerRequestResult: action.payload,
      };
    case SIGNUP_FAILURE:
      return {
        ...state,
        registerRequestLoading: false,
        registerRequestError: action.payload,
      };
    case LOGIN_REQUEST:
      return {
        ...state,
        userLoginLoading: true,
        userLoginError: null,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        userLoginLoading: false,
        userLoginError: null,
        userLoginResult: action.payload,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        userLoginLoading: false,
        userLoginError: action.payload,
      };
    case SEND_RESET_PASSWORD_REQUEST:
      return {
        ...state,
        sentForgotPasswordTokenLoading: true,
        sentForgotPasswordTokenError: null,
      };
    case SEND_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        sentForgotPasswordTokenLoading: false,
        sentForgotPasswordTokenError: null,
        sentForgotPasswordTokenResult: action.payload,
      };

    case SEND_RESET_PASSWORD_FAILURE:
      return {
        ...state,
        sentForgotPasswordTokenLoading: false,
        sentForgotPasswordTokenError: action.payload,
      };

    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPasswordLoading: true,
        resetPasswordError: null,
      };

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordError: null,
        resetPasswordResult: action.payload,
      };

    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordError: action.payload,
      };

    case CLEAR_AUTH_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
